import type { Selection } from '../types/table';

export const createDefaultTableSelection = (): Selection => {
  return {
    selectMode: null,
    selectedIds: [],
    deselectedIds: [],
  };
};
